import icon from "assets/img/icons/special-offers.svg";
import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";
import { useState } from "react";
import {
  acceptCounterOffer,
  acceptOffer,
  makeCounterOffer,
} from "services/offersService";

const ReceivedOfferConfirm = ({
  type,
  setStep,
  closeWindow,
  id,
  counterData,
  isCounter,
  refreshItems,
  playSound,
}) => {
  const { amount, days, hours } = counterData;

  const [isLoading, setIsLoading] = useState(false);

  const confirmAcceptHandler = () => {
    playSound("main");
    if (isCounter) {
      acceptCounterOffer(id, setStep, refreshItems, setIsLoading);
    } else {
      acceptOffer(id, setStep, refreshItems, setIsLoading);
    }

  };

  const getButtons = () => {
    if (type === "confirm-accept") {
      return (
        <>
          <button
            className="modal-window__footer-close"
            onClick={() => {
              playSound("main");
              setStep("accept");
            }}
          >
            No
          </button>
          <button
            className={`modal-window__footer-submit ${isLoading ? 'loading' : ''}`}
            onClick={confirmAcceptHandler}
            disabled={isLoading}
          >
            Confirm
          </button>
        </>
      );
    } else if (type === "confirm-counter") {
      return (
        <>
          <button
            className="modal-window__footer-close"
            onClick={() => {
              playSound("main");
              setStep("decline");
            }}
          >
            Back
          </button>
          <button
            className={`modal-window__footer-submit ${isLoading ? 'loading' : ''}`}
            onClick={() => {
              playSound('main');
              makeCounterOffer(id, amount, days, hours, setStep)
            }}
            disabled={isLoading}
          >
            Yes
          </button>
        </>
      );
    }
  };

  return (
    <div className="modal-window__wrapper" onClick={(e) => e.stopPropagation()}>
      <PagePopopCloseButton close={closeWindow} />
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">
          {type === "confirm-accept" && "Confirm Acceptance"}
          {type === "confirm-counter" && "Submit your counter offer?"}
        </h5>
      </header>
      <footer className="modal-window__footer">{getButtons()}</footer>
    </div>
  );
};

export default ReceivedOfferConfirm;
